// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3NXyJ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Z4FXL"};